import { InfoRow } from './InfoRow';

type InfoRowsGroupProps = {
  rows: Array<{ labelKey: string; value: string; tooltip?: string }>;
  namespace: string;
};

function InfoRowsGroup({ rows, namespace }: InfoRowsGroupProps) {
  return (
    <div className="space-y-2 paragraph-explanatory">
      {rows.map(row => (
        <InfoRow key={row.labelKey} labelKey={row.labelKey} value={row.value} namespace={namespace} infoTooltip={row.tooltip} />
      ))}
    </div>
  );
}

export { InfoRowsGroup, type InfoRowsGroupProps };
